function get_client() {
	const myRoute = document.location.hash.replace("#", "").split("/");
	if (myRoute[0] === "clients" && myRoute[1] !== undefined) return myRoute[1];
	else return null;
}

export { get_client };
